import { useEffect, useState } from 'react';
import { AlertBanner } from '@/contasis/components/AlertBanner';
import { useWorkspace } from '@/contexts/ContextoWorkspace';
import { estaHabilitadaPseMock, estaEnProcesoPseMock, suscribirseAHabilitacionPseMock } from '@/shared/habilitacionPseMock';
import { esEmpresaDemo } from '@/shared/demo';

interface HabilitacionPseBannerProps {
  onVerHabilitacion?: () => void;
}

export const HabilitacionPseBanner = ({ onVerHabilitacion }: HabilitacionPseBannerProps) => {
  const { currentEmpresa } = useWorkspace();
  const [, forzarRefresco] = useState(0);

  useEffect(() => suscribirseAHabilitacionPseMock(() => forzarRefresco((n) => n + 1)), []);

  if (!currentEmpresa || esEmpresaDemo(currentEmpresa.ruc)) return null;
  if (estaHabilitadaPseMock(currentEmpresa.ruc)) return null;

  if (estaEnProcesoPseMock(currentEmpresa.ruc)) {
    return (
      <AlertBanner variant="info" ctaLabel="Ver estado" onCta={onVerHabilitacion} dismissible={false}>
        <strong style={{ fontWeight: 600 }}>Tu habilitación está en proceso.</strong>
        <span style={{ fontWeight: 500 }}> SUNAT puede demorar hasta 24 horas en activarla — no necesitas hacer nada más por ahora.</span>
      </AlertBanner>
    );
  }

  return (
    <AlertBanner variant="warning" ctaLabel="Iniciar habilitación" onCta={onVerHabilitacion} dismissible={false}>
      <strong style={{ fontWeight: 600 }}>Esta empresa aún no puede emitir comprobantes.</strong>
      <span style={{ fontWeight: 500 }}> Completa la certificación digital en SUNAT y luego confirma su habilitación.</span>
    </AlertBanner>
  );
};
